export const primaryColor = '#415c24';
export const primaryHoverColor = '#419024';
export const dangerColor = 'red.500';
export const overflowColor = 'red.500';
